import { render, staticRenderFns } from "./HKLForm.vue?vue&type=template&id=0df21112&"
import script from "./HKLForm.vue?vue&type=script&lang=js&"
export * from "./HKLForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df21112')) {
      api.createRecord('0df21112', component.options)
    } else {
      api.reload('0df21112', component.options)
    }
    module.hot.accept("./HKLForm.vue?vue&type=template&id=0df21112&", function () {
      api.rerender('0df21112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Form/HKLForm.vue"
export default component.exports